const s = {
  name: "AdyenForPlatforms",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,33.7c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2S35.7,33.7,35,33.7z"/>
		<path class="st0" d="M20,36.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2S20.7,36.2,20,36.2z"/>
		<path class="st0" d="M16,13.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C14.8,12.7,15.3,13.2,16,13.2z"
			/>
		<path class="st0" d="M21.3,12c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,10.7,21.3,11.3,21.3,12z"
			/>
		<path class="st0" d="M24,13.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,12.7,23.3,13.2,24,13.2z"
			/>
		<path class="st0" d="M3.8,35c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S5.7,36.2,5,36.2S3.8,35.7,3.8,35z"/>
		<path class="st0" d="M33.2,30.4c0.6-0.2,1.2-0.4,1.8-0.4c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-1.4,0.6-2.7,1.5-3.5
			l-5.8-8.9c-1.4,0.8-3,1.2-4.7,1.4v6.1c2.3,0.5,4,2.5,4,4.9c0,2.8-2.2,5-5,5s-5-2.2-5-5c0-2.4,1.7-4.4,4-4.9v-6.1
			c-1.7-0.1-3.3-0.6-4.7-1.4l-5.8,8.9C9.4,32.3,10,33.6,10,35c0,2.8-2.2,5-5,5s-5-2.2-5-5c0-2.8,2.2-5,5-5c0.7,0,1.3,0.1,1.8,0.4
			l5.8-8.9C9.8,19.3,8,15.8,8,12C8,5.4,13.4,0,20,0s12,5.4,12,12c0,3.8-1.8,7.3-4.6,9.5L33.2,30.4z M32,35c0,1.7,1.3,3,3,3
			c1.6,0,3-1.3,3-3s-1.4-3-3-3C33.4,32,32,33.3,32,35z M20,38c1.6,0,3-1.3,3-3s-1.4-3-3-3c-1.7,0-3,1.3-3,3S18.4,38,20,38z M20,2
			c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10s10-4.5,10-10C30,6.5,25.5,2,20,2z M2,35c0,1.7,1.4,3,3,3s3-1.3,3-3s-1.3-3-3-3
			S2,33.3,2,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as AdyenForPlatforms
};
